/* NZ Supps — Build Your Stack interstitial (Review -> Subscribe & Save).
   The stack is PREVIEWED here from sessionStorage (nzs_pending_stack); it only commits to the real
   cart when the user clicks Continue (the lock-in). After the commit the page reloads to ?step=2 so the
   server-rendered Recharge week-plans drive the subscribe slider on the now-populated cart. */
(function () {
  var root = document.querySelector('[data-nzsc]');
  if (!root) return;
  var cfgEl = root.querySelector('[data-nzsc-config]');
  var CFG = { lines: [] };
  try { if (cfgEl) CFG = JSON.parse(cfgEl.textContent); } catch (e) { /* keep default */ }
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var PEND = null;
  try { PEND = JSON.parse(sessionStorage.getItem('nzs_pending_stack') || 'null'); } catch (e) { /* none */ }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}', v = cents / 100;
    function f(x, d) { return x.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return k.indexOf('no_decimals') > -1 ? f(v, 0) : f(v, 2); });
  }
  function sumRow(label, val, cls) { return '<div class="nzsc__sum-row' + (cls ? ' ' + cls : '') + '"><span>' + label + '</span><b>' + val + '</b></div>'; }

  /* ---------- step navigation ---------- */
  function goStep(n) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-step]'), function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-step') === String(n));
    });
    Array.prototype.forEach.call(root.querySelectorAll('.nzsc__steps li'), function (li) {
      li.classList.toggle('is-on', Number(li.getAttribute('data-dot')) <= n);
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  var backBtn = root.querySelector('[data-nzsc-back]');
  if (backBtn) backBtn.addEventListener('click', function () { goStep(1); });
  Array.prototype.forEach.call(root.querySelectorAll('[data-nzsc-checkout]'), function (b) {
    b.addEventListener('click', function () {
      if (b.classList.contains('is-going')) return; b.classList.add('is-going'); if (b.tagName === 'BUTTON') b.disabled = true;
      // NZS-SPEED-LDR-STACK: checkout dots expose their pending state.
      b.setAttribute('aria-busy', 'true');
      b.innerHTML = 'Taking you to checkout <span class="nzsc-dots" aria-hidden="true"><i></i><i></i><i></i></span>';
      // The stack saving applies automatically via the live "Build Your Stack rewards" discount
      // (reads the _StackPct / _Free line properties), so go straight to checkout, no ?discount= code.
      window.location.href = routeRoot + 'checkout';
    });
  });

  /* ---------- render the stack lines + order summary (preview from PEND, or the live cart once committed) ---------- */
  var linesEl = root.querySelector('[data-nzsc-lines]');
  var emptyEl = root.querySelector('[data-nzsc-empty]');
  function lineHtml(l, pct, nPicks) {
    var earned = l.free && (l.freeType === 'mystery' ? nPicks >= 4 : nPicks >= 3);  // sample >=3 picks, mystery >=4
    var cls = earned ? ' is-free' : ((!l.free && pct > 0) ? ' is-discount' : '');
    var img = l.image ? '<img src="' + esc(l.image) + '" alt="' + esc(l.title) + '" loading="eager" width="64" height="64">' : '';
    var meta = (l.category ? esc(l.category) + ' &middot; ' : '') + 'Qty ' + l.qty;
    var p;
    if (earned) p = '<s>' + money(l.price) + '</s> <span class="nzsc__free">FREE</span>';
    else if (!l.free && pct > 0) p = '<s>' + money(l.price) + '</s> <span class="nzsc__new">' + money(Math.round(l.price * (1 - pct / 100))) + '</span>';
    else p = money(l.price);   // paid pick OR a freebie whose tier is no longer earned -> now paid
    var idAttr = l.key ? ' data-key="' + esc(String(l.key)) + '"' : (l.vid != null ? ' data-vid="' + esc(String(l.vid)) + '"' : '');
    var rm = idAttr ? '<button type="button" class="nzsc__rm" data-nzsc-remove' + idAttr + ' aria-label="Remove ' + esc(l.title) + '">&times;</button>' : '';
    return '<div class="nzsc__line' + cls + '"><div class="nzsc__line-img">' + img + '</div>' +
      '<div class="nzsc__line-t"><div class="nzsc__line-n">' + esc(l.title) + '</div><div class="nzsc__line-m">' + meta + '</div></div>' +
      '<div class="nzsc__line-p">' + p + '</div>' + rm + '</div>';
  }
  function picksOf(stack) { var pk = {}; stack.forEach(function (l) { if (!l.free && l.category) pk[String(l.category).toLowerCase()] = 1; }); return Object.keys(pk).length; }
  function pctOf(nPicks) { return nPicks >= 4 ? 10 : nPicks >= 2 ? 5 : 0; }
  function render(stack, rest) {
    var nPicks = picksOf(stack), pct = pctOf(nPicks);   // re-derive from live picks — single source of truth
    if (linesEl) {
      var h = '<div class="nzsc__lines">' + stack.map(function (l) { return lineHtml(l, l.free ? 0 : pct, nPicks); }).join('') + '</div>';
      if (rest.length) h += '<div class="nzsc__divider"><span>Also in your cart</span></div><div class="nzsc__lines nzsc__lines--rest">' + rest.map(function (l) { return lineHtml(l, 0, nPicks); }).join('') + '</div>';
      linesEl.innerHTML = h;
    }
    var earnedFree = 0, paidStack = 0, stackItems = 0, unearnedFree = 0, restPaid = 0, restItems = 0;
    stack.forEach(function (l) {
      if (l.free) { if (l.freeType === 'mystery' ? nPicks >= 4 : nPicks >= 3) earnedFree += l.price; else unearnedFree += l.price; }
      else { paidStack += l.price; stackItems += l.qty; }
    });
    rest.forEach(function (l) { restPaid += l.price; restItems += l.qty; });
    var saving = Math.round(paidStack * pct / 100), total = (paidStack - saving) + unearnedFree + restPaid;
    var rows = root.querySelector('[data-nzsc-sumrows]'), totalEl = root.querySelector('[data-nzsc-total]');
    var html = sumRow('Your stack (' + stackItems + ' item' + (stackItems === 1 ? '' : 's') + ')', money(paidStack));
    if (earnedFree > 0) html += sumRow('Free samples + gift', '<s>' + money(earnedFree) + '</s> FREE', 'save');
    if (unearnedFree > 0) html += sumRow('Extras (now paid)', money(unearnedFree));
    if (saving > 0) html += sumRow('Stack saving (' + pct + '%)', '&minus;' + money(saving), 'save');
    if (restPaid > 0) html += sumRow('Rest of cart (' + restItems + ' item' + (restItems === 1 ? '' : 's') + ')', money(restPaid));
    if (rows) rows.innerHTML = html;
    if (totalEl) totalEl.innerHTML = money(total);
  }
  function fromCart(cart) {
    var stack = [], rest = [];
    cart.items.forEach(function (it) {
      var pr = it.properties || {};
      var ft = pr._Free ? (/mystery/i.test(pr._Free) ? 'mystery' : 'sample') : null;
      var l = { key: it.key, vid: it.variant_id, title: it.product_title || it.title, image: it.image, qty: it.quantity, price: it.original_line_price, category: pr.Category, free: !!pr._Free, freeType: ft };
      if (pr._Stack) stack.push(l); else rest.push(l);
    });
    return { stack: stack, rest: rest };
  }
  var committed = false;
  function showEmpty() {
    if (emptyEl) emptyEl.hidden = false;
    Array.prototype.forEach.call(root.querySelectorAll('[data-step]'), function (s) { s.style.display = 'none'; });
    var head = root.querySelector('.nzsc__head'); if (head) head.style.display = 'none';
  }
  function refresh() {
    return fetch(routeRoot + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var c = fromCart(cart);
      var atStep2 = /[?&]step=2/.test(location.search);
      var havePend = !!(PEND && PEND.lines && PEND.lines.length);
      if (havePend && !atStep2) {                            // fresh build this session (preview) wins over any stale committed _Stack line
        committed = false; render(PEND.lines, c.rest);
      } else if (c.stack.length) {                           // committed (reloaded after Continue, or resuming a saved stack)
        committed = true; render(c.stack, c.rest);
        var np = picksOf(c.stack), npct = pctOf(np);          // keep cart attrs honest (the Function caps anyway)
        if (String((cart.attributes || {})._StackPct || '') !== String(npct)) {
          fetch(routeRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _StackPct: String(npct), _StackPicks: String(np) } }) });
        }
      } else { showEmpty(); }
      return cart;
    }).catch(function () { /* leave server-rendered fallbacks */ });
  }
  // inline remove (committed cart line by key, or preview PEND line by variant id)
  if (linesEl) linesEl.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nzsc-remove]'); if (!btn || btn.disabled) return;
    e.preventDefault(); btn.disabled = true;
    // NZS-SPEED-LDR-STACK: dim and isolate only the line being removed.
    var row = btn.closest('.nzsc__line');
    if (row) { row.classList.add('is-removing'); row.setAttribute('aria-busy', 'true'); }
    function removeDone() { if (row && row.isConnected) { row.classList.remove('is-removing'); row.removeAttribute('aria-busy'); btn.disabled = false; } }
    var key = btn.getAttribute('data-key'), vid = btn.getAttribute('data-vid');
    if (key) {
      fetch(routeRoot + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
        .then(function () { return refresh(); })
        .then(function () { removeDone(); document.dispatchEvent(new CustomEvent('nzs:cart-changed')); })
        .catch(removeDone);
    } else if (vid != null && PEND) {
      var v = String(vid);
      PEND.lines = (PEND.lines || []).filter(function (l) { return String(l.vid) !== v; });
      PEND.paid = (PEND.paid || []).filter(function (it) { return String(it.id) !== v; });
      PEND.free = (PEND.free || []).filter(function (it) { return String(it.id) !== v; });
      var np = picksOf(PEND.lines), npct = pctOf(np);
      PEND.pct = npct; PEND.attrs = PEND.attrs || {}; PEND.attrs._StackPct = String(npct); PEND.attrs._StackPicks = String(np);
      try { sessionStorage.setItem('nzs_pending_stack', JSON.stringify(PEND)); } catch (e) { }
      refresh().then(removeDone);
    }
  });
  refresh().then(function () { if (/[?&]step=2/.test(location.search)) goStep(2); });

  /* ---------- Continue = lock-in: commit the pending stack to cart, then reload to step 2 ---------- */
  function sbAdd(items) { return fetch(routeRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw new Error((e && e.description) || 'Could not add to cart'); }); } return r.json(); }); }
  // A fresh build REPLACES any prior committed stack: zero out existing _Stack lines before adding the new ones
  // (else a leftover committed pick from an abandoned flow would merge/duplicate onto the new stack).
  function clearCommittedStack() {
    return fetch(routeRoot + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var upd = {};
      (cart.items || []).forEach(function (it) { if (it.properties && it.properties._Stack) upd[it.key] = 0; });
      if (!Object.keys(upd).length) return null;
      return fetch(routeRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) });
    });
  }
  var topNext = root.querySelector('[data-nzsc-top-continue]');
  var topNextLabel = topNext && topNext.innerHTML;
  if (topNext) topNext.addEventListener('click', function () { var n = root.querySelector('[data-nzsc-next]'); if (n) n.click(); });
  var nextBtn = root.querySelector('[data-nzsc-next]');
  if (nextBtn) nextBtn.addEventListener('click', function () {
    if (committed || !PEND) { goStep(2); return; }          // already committed -> just advance
    nextBtn.disabled = true; nextBtn.setAttribute('aria-busy', 'true'); var orig = nextBtn.innerHTML; nextBtn.innerHTML = 'Locking it in <span class="nzsc-dots" aria-hidden="true"><i></i><i></i><i></i></span>';
    /* NZS-SPEED-LDR-STACK: top Continue is busy only when this async commit starts. */
    if (topNext) { topNext.disabled = true; topNext.setAttribute('aria-busy', 'true'); topNext.innerHTML = topNextLabel + ' <span class="nzsc-dots" aria-hidden="true"><i></i><i></i><i></i></span>'; }
    clearCommittedStack()                                    // a fresh build REPLACES any leftover committed stack (no merge/duplicate)
      .then(function () { return sbAdd(PEND.paid); })
      .then(function () { return (PEND.free && PEND.free.length) ? sbAdd(PEND.free).catch(function (e) { console.warn('[nzsc] free extras skipped (out of stock?)', e); }) : null; })
      .then(function () { return fetch(routeRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: PEND.attrs }) }); })
      .then(function () { try { sessionStorage.removeItem('nzs_pending_stack'); localStorage.removeItem('nzs_stack_saved'); } catch (e) { } window.location.href = routeRoot + 'pages/your-stack?step=2'; })
      .catch(function (err) {
        console.error('[nzsc] commit failed', err);
        nextBtn.disabled = false; nextBtn.removeAttribute('aria-busy'); nextBtn.innerHTML = orig;
        if (topNext) { topNext.disabled = false; topNext.removeAttribute('aria-busy'); topNext.innerHTML = topNextLabel; }
        var ce = root.querySelector('[data-nzsc-commit-err]');
        if (!ce) { ce = document.createElement('p'); ce.setAttribute('data-nzsc-commit-err', ''); ce.style.cssText = 'color:#c0392b;font-size:13px;margin-top:8px;text-align:center'; if (nextBtn.parentNode) nextBtn.parentNode.insertBefore(ce, nextBtn.nextSibling); }
        ce.textContent = (err && err.message) ? ('We could not lock in your stack: ' + err.message + '. One of your picks may have just sold out, so head back and swap it.') : 'Something went wrong locking in your stack. Please try again.';
      });
  });

  /* ---------- subscription slider ---------- */
  var supply = CFG.supply || '30-day';
  var is60 = supply.indexOf('60') === 0;
  var lo = is60 ? 8 : 4, hi = is60 ? 16 : 8;
  var subLines = (CFG.lines || []).filter(function (l) { return !l.free && l.plans && l.plans.length; });
  var weekSet = {};
  subLines.forEach(function (l) { l.plans.forEach(function (p) { if (p.weeks >= lo && p.weeks <= hi && Number(p.tier) > 0) weekSet[p.weeks] = 1; }); });
  var weeks = Object.keys(weekSet).map(Number).sort(function (a, b) { return a - b; });

  var sliderWrap = root.querySelector('[data-nzsc-slider]');
  var noPlans = root.querySelector('[data-nzsc-noplans]');
  var subscribeBtn = root.querySelector('[data-nzsc-subscribe]');
  var range = root.querySelector('[data-nzsc-range]');
  var valEl = root.querySelector('[data-nzsc-weekval]');
  var ticksEl = root.querySelector('[data-nzsc-ticks]');

  function chosenWeeks() { return weeks[Number(range.value)] || weeks[0]; }
  function renderVal() {
    if (valEl) valEl.textContent = 'Every ' + chosenWeeks() + ' weeks';
    if (range && range.max > 0) { var pct = (Number(range.value) / Number(range.max)) * 100; range.style.setProperty('--nzsc-fill', pct + '%'); }
  }

  if (!weeks.length) {
    if (sliderWrap) sliderWrap.hidden = true;
    if (noPlans) noPlans.hidden = false;
    if (subscribeBtn) subscribeBtn.style.display = 'none';
  } else {
    if (sliderWrap) sliderWrap.hidden = false;
    range.min = 0; range.max = weeks.length - 1; range.step = 1;
    var def = weeks.indexOf(6); if (def < 0) def = weeks.indexOf(8); if (def < 0) def = Math.floor(weeks.length / 2);
    range.value = def;
    renderVal();
    range.addEventListener('input', renderVal);
    if (ticksEl) ticksEl.innerHTML = weeks.map(function (w) { return '<span>' + w + 'w</span>'; }).join('');

    // per-line "ship a different flavour each delivery" — only multi-flavour lines that can actually subscribe
    var rotateLines = subLines.filter(function (l) {
      return l.multiFlavour && l.plans.some(function (p) { return p.weeks >= lo && p.weeks <= hi && Number(p.tier) > 0; });
    });
    var rotateListEl = root.querySelector('[data-nzsc-rotate-list]');
    if (rotateListEl && rotateLines.length) {
      rotateListEl.hidden = false;
      rotateListEl.innerHTML = '<div class="nzsc__rotate-h">Keep it interesting?</div>' +
        rotateLines.map(function (l) {
          return '<label class="nzsc__rotate-row"><input type="checkbox" data-nzsc-rotate data-vid="' + esc(String(l.vid)) + '">' +
            '<span><b>Ship a different flavour each delivery</b><i>' + esc(l.title) + '</i></span></label>';
        }).join('');
    }
  }

  /* ---------- flavour rotation: tag checked multi-flavour lines AFTER the selling_plan re-key ---------- */
  // change.js REPLACES a line's properties, so MERGE the existing ones (_Stack/Category/…) and re-assert the
  // selling_plan to keep the line subscribed. Best-effort: a failure here never blocks the subscribe success.
  function applyRotations() {
    var checked = Array.prototype.filter.call(root.querySelectorAll('[data-nzsc-rotate]'), function (c) { return c.checked; });
    if (!checked.length) return Promise.resolve();
    var want = {}; checked.forEach(function (c) { want[String(c.getAttribute('data-vid'))] = 1; });
    return fetch(routeRoot + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var chain = Promise.resolve();
      cart.items.forEach(function (it) {
        if (!want[String(it.variant_id)]) return;
        var props = {}, ip = it.properties || {};
        for (var k in ip) { if (Object.prototype.hasOwnProperty.call(ip, k)) props[k] = ip[k]; }
        props['Flavour rotation'] = 'Ship a different flavour each delivery';
        var body = { id: it.key, properties: props };
        var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.id;
        if (sp != null) body.selling_plan = sp;
        chain = chain.then(function () { return fetch(routeRoot + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }); });
      });
      return chain;
    }).catch(function () { /* rotation is best-effort */ });
  }

  /* ---------- subscribe: mark the cart + set selling_plan on each subscribable line ---------- */
  if (subscribeBtn) subscribeBtn.addEventListener('click', function () {
    if (!weeks.length) return;
    var W = chosenWeeks();
    subscribeBtn.disabled = true; subscribeBtn.setAttribute('aria-busy', 'true'); subscribeBtn.innerHTML = 'Setting it up <span class="nzsc-dots" aria-hidden="true"><i></i><i></i><i></i></span>';
    // want: variant_id -> selling_plan id. Build-your-stack subscription is ALWAYS 5% (PDPs/quiz use
    // the 10% plans); pin 5% so the stack never grabs a 10% plan once those exist. Matches the 'extra 5%' copy.
    var targetTier = 1;   // NZS-STACKSUB-0905: composed stack plans are gone; tier 1 = the ordinary 10% plans   // 4 picks -> tier 4 (15% = 10% stack + 5% sub); 2-3 -> tier 2 (10% = 5% stack + 5% sub)
    // want: variant_id -> FULL list of in-range composed-stack plan ids, NEAREST week to W first. Keeping the whole
    // list (not just the best) lets a line fall back to the next-nearest week if its chosen plan fails to
    // apply (e.g. a transient sync gap) -> the subscribe never dead-ends to "Try again" while any week works.
    var wantList = {};
    subLines.forEach(function (l) {
      var inRange = l.plans.filter(function (p) { return p.weeks >= lo && p.weeks <= hi; });
      if (!inRange.length || l.vid == null) return;
      var pool = inRange.filter(function (p) { return Number(p.tier) === targetTier; });
      if (!pool.length) return;            // no 5% plan in range -> leave this line one-time (never apply 10%)
      wantList[l.vid] = pool.sort(function (a, b) { return Math.abs(a.weeks - W) - Math.abs(b.weeks - W); })
        .map(function (p) { return String(p.id); });
    });
    var tried = {}, attempt = {}, applied = 0;
    // ponytail: re-fetch the cart each pass so we change the line by its CURRENT key (a selling_plan change
    // re-keys the line; there is no batch selling-plan API). A failed week retries the next-nearest week.
    function step() {
      return fetch(routeRoot + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var t = null;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          var list = wantList[it.variant_id];
          if (!list || tried[it.key]) continue;
          var cur = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.id;
          if (cur != null && list.indexOf(String(cur)) > -1) { tried[it.key] = 1; applied++; continue; } // already on a valid plan
          t = it; break;
        }
        if (!t) return null;
        var vid = t.variant_id, idx = attempt[vid] || 0, planId = wantList[vid][idx];
        return fetch(routeRoot + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: t.key, selling_plan: planId }) })
          .then(function (r) {
            if (r.ok) { tried[t.key] = 1; applied++; }
            else {                                   // this week failed -> try the next-nearest week for this line
              attempt[vid] = idx + 1;
              if (attempt[vid] >= wantList[vid].length) { tried[t.key] = 1; console.warn('[nzsc] subscribe: no working week for', t.product_title || vid); }
            }
            return step();
          })
          .catch(function () { attempt[vid] = idx + 1; if (attempt[vid] >= wantList[vid].length) tried[t.key] = 1; return step(); });
      });
    }
    fetch(routeRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _StackSub: 'yes' } }) })
      .then(step).then(function () {
        if (!applied) { subscribeBtn.disabled = false; subscribeBtn.removeAttribute('aria-busy'); subscribeBtn.textContent = 'Try again'; return; }
        subscribeBtn.removeAttribute('aria-busy');
        return applyRotations().then(function () {
          var rotated = root.querySelectorAll('[data-nzsc-rotate]:checked').length;
          var done = root.querySelector('[data-nzsc-done]');
          var subCard = root.querySelector('.nzsc__sub-card');
          var msg = root.querySelector('[data-nzsc-done-msg]');
          if (msg) msg.innerHTML = 'Your stack reships every <b>' + W + ' weeks</b>, with a fresh mystery gift in every box' + (rotated ? ' and a new flavour on your chosen items' : '') + '. Fall behind? Push it back or skip from your account anytime. No lock-in.';
          if (subCard) subCard.hidden = true;
          if (done) done.hidden = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }).catch(function (e) {
        console.error('[nzsc] subscribe failed', e);
        subscribeBtn.disabled = false; subscribeBtn.removeAttribute('aria-busy'); subscribeBtn.textContent = 'Try again';
      });
  });
})();
